import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'
import _ from 'lodash';
import cartaLub from '../../../functions/cartalub';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option dato1={props.elemento.logo}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

// Lista de mecanismos
const DetallePl = ({elemento}) => {
  
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>

    </tr>
  )
};

const ListaPl = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

class CarPdfEq2 extends React.Component {
  state={listCL: this.props.list, listImg: this.props.list2,
    procBtn: 0, permiteBtn1: true, permiteBtn2: true, confirmaAct: false, open: false
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

//ACTUALIZAR BD
crudBDInd = async (operacionCRUD, args, i)=>{
  if(args.ctrlCampo === 'CRUD'){
    const {data} = await operacionCRUD({
      variables: args
    });

//Se utiliza para traer el _id del documento creado
    if(args.ctrl_id === 'SI_ID'){
      if(Object.values(data)[0]._id){
        return Object.values(data)[0]._id
      }else{
        return 0
      }
    }
  }else{
    if(args.ctrlCampo === "MANY"){
      const {data} = await operacionCRUD({
        variables: args
      });
    }
  }
}

//ENVIO PARA ACTUALIZAR BD
updColeccInd = async (crudColecc, argsCrud, totDocCRUD)=>{
  let codigo = 0
  if(argsCrud[0].ctrl_id === 'SI_ID'){
    codigo = await this.crudBDInd(crudColecc[0], argsCrud[0], 0)
  }else{
    await this.crudBDInd(crudColecc[0], argsCrud[0], 0)
  }
  if(codigo!==0){
    for(let i=1; i<totDocCRUD; i++){
      argsCrud[i]._id = codigo
    }
  }
  for(let i=1; i<totDocCRUD; i++){
    await this.crudBDInd(crudColecc[i], argsCrud[i], i)
  }
}
  
  handleSubmit = async (ev, list, list2, args)=>{
    if(list.length>0){
      await cartaLub(
        list,
        list2,
        args,
        'S',
        {
          allPlantaRtes2: this.props.allPlantaRtesC, 
          productos: this.props.allProducto, 
          fecha: this.props.fecha
        }
      );
    }
    this.setState({permiteBtn1: true, open: false, confirmaAct: false})
  }


  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }

  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.list!==prevProps.list){
      this.setState({listCL: this.props.list})
    }
    if(this.props.list2!==prevProps.list2){
      this.setState({listImg: this.props.list2})
    }
  }


  render(){
    const {listCL, listImg, permiteBtn1, permiteBtn2, confirmaAct, open} = this.state;
    let mensaje1 = "GENERAR PDF"
    let imgIcon1 = "images/archivo_32.png"
    
  let list = []
  if(listCL){
    list = listCL
    for(let i=0; i<listCL.length; i++){
      list[i].idPlanta = i
    }
  }

  let list2 = []
  if(listImg){
    list2 = listImg
    for(let i=0; i<listImg.length; i++){
      list2[i].idPlanta = i
    }
  }
  let slcm=""
  if(localStorage.getItem('userLogin')==="slcm@slcm.com"){
    slcm="slcm"
  }
  return (
    <div>
      <List selection>
        <TitDer list={this.props.list} textBoton1="Cartas de Lubricación" btnNuevo={"NO"} styles={this.props.styles}/>

        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.handleSubmit(ev, list, list2, this.props.args)
              :permiteBtn2?
                (ev)=>this.handleAnexos(ev, list, this.props.args)
                :()=>{}                
            :()=>{}}
          >
          <div className="ui three column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '50%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaEmp styles={this.props.styles} list={this.props.list1}
                    handleChange={this.props.handleChange} />
                </Form.Field>
              </div>
              {permiteBtn1 &&
                <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                  <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                    open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                </div>
              }
            </div>  
          </div>
            <div style={{height: '55em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Mecanismo</th>
                  </tr>
                </thead>
                <ListaPl list={list}/>
              </table>
              <p></p>
            </div>
            <hr></hr>
          </Form>
        </div>
      </List>
    </div>
  )
  }
};

export default compose( 
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes3',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allProducto, {name:'allProducto'}),
  // graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  // graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  // graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  // // graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  // //   options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  // // graphql(queries.query.allEmpresaInd, {name:'allEmpresaInd',
  // //   options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  // graphql(queries.mutation.editEmpresaMany, {name:'editEmpresaMany'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.allPlantaRtes, { name: 'allPlantaRtesC' }), // sin options
)(CarPdfEq2)

